import { Components, Theme } from '@mui/material/styles';

export const OraMuiSwitch: Components<Theme>['MuiSwitch'] = {
  styleOverrides: {
    root: {
      width: 42,
      height: 26,
      padding: 0,
    },
    switchBase: {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: 'var(--green)',
        '& + .MuiSwitch-track': {
          backgroundColor: 'var(--green)',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: 'var(--type-heading-dark)',
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.3,
      },
    },
    thumb: {
      backgroundColor: 'var(--type-heading-dark) !important',
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    track: {
      borderRadius: 26 / 2,
      backgroundColor: 'var(--surface-input)',
      opacity: 1,
      transition: 'background-color 500ms',
    },
  },
};
